import { api } from '../..';
import { mapApiToEntity } from './mapper';
import { PropertyType } from '../../../common';

export const getCurrencies = (): Promise<PropertyType> =>
	api.get('/currency').then((res) => {
		return mapApiToEntity(res.data);
	});
